import Landing from '@/services/Landing.js'

export default {
  setSettings({ commit }, settings = {}) {
    commit('setSettings', settings)
  },

  setPalette({ commit }, palette = []) {
    commit('setPalette', palette)
  },

  setSEO({ commit }, seo = {}) {
    commit('setSEO', seo)
  },

  setJavascript({ commit }, js = {}) {
    commit('setJavascript', js)
  },

  addColor({ state, commit, dispatch }, { color = null, stack = 'undo', stackToClear = 'redo' } = {}) {
    if (!state.palette.includes(color) && state.palette.length < 16) {
      commit('addColor', color)

      dispatch(
        'history/pushToStack',
        {
          stack,
          action: 'settings/removeColor',
          params: { color },
          stackToClear,
        },
        { root: true }
      )
    }
  },

  removeColor({ state, commit, dispatch }, { color = null, stack = 'undo', stackToClear = 'redo' } = {}) {
    if (state.palette.includes(color)) {
      commit('removeColor', color)

      dispatch(
        'history/pushToStack',
        {
          stack,
          action: 'settings/addColor',
          params: { color },
          stackToClear,
        },
        { root: true }
      )
    }
  },

  saveSettings({ state }, id = '') {
    Landing.setDynamicLanding({ id, settings: state })
  },
}
